import { GET, POST, PUT, DELETE } from './executer';
import apiServiceInstance from './apiService';

export interface AccountUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  isActive?: boolean;
  authType?: string;
  phoneNumber?: string;
  jobTitle?: string;
  groups?: { id: string; name: string; isActive?: boolean }[];
  createdAt?: string;
  updatedAt?: string;
}

export interface AddUserRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  jobTitle?: string;
  phoneNumber?: string;
  role?: string;
  sendForgotPasswordEmail?: boolean;
}

class UsersManagementService {
  /**
   * Get all users in the account
   */
  async getUsers() {
    return await apiServiceInstance.client.execute<AccountUser[]>(GET, '/api/admin/users');
  }

  /**
   * Add a new user to the account
   */
  async addUser(data: AddUserRequest) {
    return await apiServiceInstance.client.execute<{ email: string }>(
      POST,
      '/api/admin/add-user',
      data
    );
  }

  /**
   * Delete a user from the account
   */
  async deleteUser(userId: string) {
    return await apiServiceInstance.client.execute(DELETE, `/api/admin/users/${userId}`);
  }

  /**
   * Update a user's role (developer, collaborator, account-admin)
   */
  async updateUserRole(userId: string, role: string) {
    return await apiServiceInstance.client.execute<{ role: string }>(
      PUT,
      `/api/admin/users/${userId}/role`,
      { role }
    );
  }

  /**
   * Update a user's firstName, lastName, phoneNumber
   */
  async updateUser(userId: string, data: { firstName?: string; lastName?: string; phoneNumber?: string }) {
    return await apiServiceInstance.client.execute<{ firstName?: string; lastName?: string; phoneNumber?: string }>(
      PUT,
      `/api/admin/users/${userId}`,
      data
    );
  }

  /**
   * Activate a user
   */
  async activateUser(userId: string) {
    return await apiServiceInstance.client.execute(
      POST,
      `/api/admin/users/${userId}/activate`
    );
  }

  /**
   * Deactivate a user
   */
  async deactivateUser(userId: string) {
    return await apiServiceInstance.client.execute(
      POST,
      `/api/admin/users/${userId}/deactivate`
    );
  }

  /**
   * Send forgot password email to a user
   */
  async sendForgotPasswordEmail(email: string) {
    return await apiServiceInstance.client.execute(
      POST,
      '/api/admin/forgot-password',
      { email }
    );
  }
}

const usersManagementServiceInstance = new UsersManagementService();
export default usersManagementServiceInstance;
